import {emotionStyled} from '@packages/utilities/styled';

import {Stack} from '../Stack';

export const RadioGroupView = emotionStyled(Stack)(
  {},
  {
    componentName: 'RadioGroup',
  }
);
